import { render, staticRenderFns } from "./AbaAreaMonitorada.vue?vue&type=template&id=0ab0f4c5&scoped=true&lang=pug"
import script from "./AbaAreaMonitorada.vue?vue&type=script&lang=js"
export * from "./AbaAreaMonitorada.vue?vue&type=script&lang=js"
import style0 from "./AbaAreaMonitorada.vue?vue&type=style&index=0&id=0ab0f4c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0f4c5",
  null
  
)

export default component.exports